/*

  The central source of all colors style.
  This should always match the Figma File "Color System June '20"
  Figma URL - https://www.figma.com/file/rS3BGKSGiLr0cCdGplNl2q/Color-System-June-'20
  Last Updated - "Tue Jun 15 2021 13:18:23 GMT+0530 (India Standard Time)"

*/

const COLORS = {
	BRAND_COLORS: {
		WHITE: '#ffffff',
		SLATE_BLACK: '#111111',
		PURPS: '#8000ff',
		HEADOUT_CANDY: '#ff007a',
	},
	BACKGROUND: {
		FLOATING_PURPS: '#f8f6ff',
		GENTLE_WARNING: '#ffd8d8',
		FADED_PALE: '#fff8ef',
		FADED_GREEN: '#f2fdeb',
		FADED_CANDY: '#fff2f8',
		YOUNG_ORANGE: '#ffe7ce',
		SOOTHING_GREEN: '#dbfddb',
	},
	GRAY: {
		G1: '#222222',
		G3: '#666666',
		G4: '#888888',
		G5: '#c4c4c4',
		G6: '#e2e2e2',
		G7: '#f0f0f0',
		G8: '#f8f8f8',
		G2: '#444444',
		G4A: '#9f9f9f',
		G9: '#999999',
	},
	WARNING_RED: {
		LIGHT_TONE_2: '#ef9494',
		TERTIARY: '#bd0303',
		DARK_TONE: '#570101',
		LIGHT_TONE_1: '#ef4c4c',
		LIGHT_TONE_3: '#ffd8d8',
		EXTRA: '#ffe5e5',
	},
	PRIMARY: {
		DREAMY_PALE: '#ffc5bb',
		HOLA_YELLOW: '#ffe900',
		PEACHY_ORANGE: '#ff9d7c',
		SUBTLE_GREEN: '#d2f260',
		JOY_MUSTARD: '#ffbc00',
		OKAY_GREEN: '#15d676',
		WARNING_RED: '#ef0404',
		OCEAN_BLUE: '#00c4eb',
		LINK_BLUE: '#1355f0',
	},
	DREAMY_PALE: {
		SECONDARY: '#e5b1a8',
		TERTIARY: '#cc9e96',
		DARK_TONE: '#a4766e',
		LIGHT_TONE_2: '#fff4f2',
		LIGHT_TONE_1: '#ffdad4',
	},
	HOLA_YELLOW: {
		SECONDARY: '#e5d200',
		TERTIARY: '#ccba00',
		LIGHT_TONE_2: '#fffbcc',
		LIGHT_TONE_1: '#fff266',
		LIGHT_TONE_3: '#fffde5',
	},
	TEXT: {
		HOLA_YELLOW_3: '#807400',
		PEACHY_ORANGE_3: '#a4563b',
		OKAY_GREEN_3: '#088229',
		PURPS_3: '#6600cc',
		JOY_MUSTARD_3: '#906100',
		HEADOUT_CANDY_1: '#e5006e',
		WARNING_RED_1: '#d60404',
		BEACH: '#037B95',
		LINK_BLUE_1: '#114cd6',
	},
	PEACHY_ORANGE: {
		TERTIARY: '#cc7e63',
		SECONDARY: '#e58d70',
		LIGHT_TONE_2: '#ffece5',
		LIGHT_TONE_1: '#ffc4b0',
	},
	SUBTLE_GREEN: {
		SECONDARY: '#bcd956',
		TERTIARY: '#a6bf4c',
		LIGHT_TONE_2: '#f4ffcc',
		LIGHT_TONE_1: '#e6ff8b',
		LIGHT_TONE_3: '#f9ffe5',
	},
	PURPS: {
		SECONDARY: '#7300e5',
		DARK_TONE: '#330066',
		LIGHT_TONE_2: '#b266ff',
		LIGHT_TONE_1: '#9933ff',
		LIGHT_TONE_3: '#ecd9ff',
	},
	JOY_MUSTARD: {
		SECONDARY: '#e5a900',
		TERTIARY: '#cc9600',
		LIGHT_TONE_2: '#fff2cc',
		LIGHT_TONE_1: '#ffd766',
		LIGHT_TONE_3: '#fff8e5',
	},
	BUTTON: { OKAY_GREEN: '#13bd68' },
	OKAY_GREEN: {
		TERTIARY: '#10a35a',
		DARK_TONE: '#095730',
		LIGHT_TONE_2: '#aaffd4',
		LIGHT_TONE_1: '#49ee9c',
		LIGHT_TONE_3: '#deffee',
	},
	HEADOUT_CANDY: {
		TERTIARY: '#cc0062',
		DARK_TONE: '#660031',
		LIGHT_TONE_2: '#ff66af',
		LIGHT_TONE_1: '#fe3394',
		LIGHT_TONE_3: '#ffe5f2',
	},
	OCEAN_BLUE: {
		SECONDARY: '#00afd1',
		TERTIARY: '#009ab8',
		DARK_TONE: '#004452',
		LIGHT_TONE_2: '#a4f0ff',
		LIGHT_TONE_1: '#2fcceb',
		LIGHT_TONE_3: '#d6f8ff',
	},
	LINK_BLUE: {
		TERTIARY: '#0f43bd',
		DARK_TONE: '#071f57',
		LIGHT_TONE_2: '#7ba3ff',
		LIGHT_TONE_1: '#4377f0',
		LIGHT_TONE_3: '#adc6ff',
	},
	PURPS_LEVEL: {
		10: '#F3E9FF',
		15: '#E6D1FF',
		20: '#E6CCFF',
		25: '#DFBFFF',
		30: '#D9B3FF',
		35: '#D2A6FF',
		40: '#CC99FF',
		45: '#CC99FF',
		50: '#C68CFF',
	},

	// Everything below are legacy colours, soon to be deprecated.

	DARK_BLUE: '#1A4D57',
	GREEN_3: '#088943',
	BEACH: '#03829D',
	rhapsody: '#EC1943',
	teal: '#24A1B2',
	white: '#FFFFFF',
	ether: '#4FC3F7',
	dune: '#FFBB58',
	'tea-green': '#34A853',
	'medium-slate-blue': '#7B68DB',
	'davy-grey': '#545454',
	grey: '#757575',
	gallery: '#bababa',
	'daddy-grey': '#DADADA',
	chalk: '#ebebeb',
	PINK: '#ec1943',
	LIGHT_PINK: '#ed5b78',
	PALE_PINK: '#fde8ec',
	YELLOW: '#ffbb58',
	GREEN: '#08841f',
	LIGHT_GREEN: '#33b459',
	CYAN: '#24a1b2',
	CHARCOAL: '#545454',
	PURPLE: '#7b68db',
	WHITE: '#ffffff',
	BLACK: '#000',
};

module.exports = COLORS;
